import Link from "next/link"
import "./header.css"

class Header extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isHamburgerActive: false,
      isMobileMenuActive: false,
      winWidth: 0,
      winHeight: 0,
      menuItems: [
        { name: "Who We Are", path: "/who-we-are" },
        { name: "Our Approach", path: "/our-approach" },
        { name: "Our Partners", path: "/our-partners" },
        { name: "Contact Us", path: "/contact-us" },
      ],
      page:
        this.props.page == "error"
          ? "colored error"
          : this.props.page == "tnc"
          ? "colored tnc"
          : "",
    }
    this.handleRouteChange = this.handleRouteChange.bind(this)
    this.ShowMobileMenu = this.ShowMobileMenu.bind(this)
  }
  RenderLogoSrc() {
    if (this.props.page == "error" || this.props.page == "tnc") {
      return this.props.data.darkLogo
    }
    if (this.state.isHamburgerActive) {
      return this.props.data.brightLogo
    } else {
      if (this.props.colorType == "colored") {
        return this.props.data.darkLogo
      } else {
        return this.props.data.brightLogo
      }
    }
  }
  handleRouteChange() {
    this.ShowMobileMenu()
  }
  ShowMobileMenu() {
    this.setState({
      isHamburgerActive: !this.state.isHamburgerActive,
      isMobileMenuActive: !this.state.isMobileMenuActive,
    })
    document.documentElement.classList.toggle("open")
    document.body.classList.toggle("open")
  }
  CreateMenu(currentPage, type) {
    return this.state.menuItems.map((item, index) => {
      return (
        <li className={currentPage == item.path ? "current" : ""} key={index}>
          <Link href={item.path}>
            {type == "desktop" ? (
              <a hrefLang="en">{item.name}</a>
            ) : (
              <a hrefLang="en" onClick={this.handleRouteChange}>
                {item.name}
              </a>
            )}
          </Link>
        </li>
      )
    })
  }
  updateDimensions = () => {
    this.setState({
      winWidth: window.innerWidth,
      winHeight: window.innerHeight,
    })
    if (this.state.winWidth > 991) {
      if (this.state.isMobileMenuActive) {
        this.setState({
          isHamburgerActive: false,
          isMobileMenuActive: false,
        })
        document.documentElement.classList.remove("open")
        document.body.classList.remove("open")
      }
    }
  }
  componentDidMount() {
    window.addEventListener("load", this.updateDimensions)
    window.addEventListener("resize", this.updateDimensions)
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions)
  }
  render() {
    var backToPartnerBar = null
    if (this.props.currentPagePath.indexOf("our-partners/") !== -1) {
      backToPartnerBar = (
        <div className={"back-to-page " + this.props.colorType}>
          <div className="container">
            <div className="inner-container">
              <Link href="/our-partners">
                <a>Back to Our Partners</a>
              </Link>
            </div>
          </div>
        </div>
      )
    }
    return (
      <div>
        <header
          className={
            this.props.heightType +
            " " +
            this.props.colorType +
            " " +
            this.state.page
          }
          style={{
            backgroundColor: this.props.backgroundColor,
            backgroundImage: this.props.backgroundImage,
          }}
        >
          <div className="container">
            <div className="inner-container">
              <div className="row">
                <div className="logo">
                  <Link href="/">
                    <a hrefLang="en">
                      <img src={this.RenderLogoSrc()} alt="" />
                    </a>
                  </Link>
                </div>
                <nav>
                  <ul>
                    {this.CreateMenu(this.props.currentPagePath, "desktop")}
                  </ul>
                </nav>
                <div
                  className={
                    this.state.isHamburgerActive === true
                      ? "sty-close hamburger"
                      : "hamburger"
                  }
                  onClick={this.ShowMobileMenu}
                >
                  <span className="line"></span>
                  <span className="line"></span>
                  <span className="line"></span>
                </div>
              </div>
            </div>
          </div>
          <div
            className={
              this.state.isMobileMenuActive === true ? "open menu-m" : "menu-m"
            }
          >
            <div className="wrapper">
              <nav>
                <ul>{this.CreateMenu(this.props.currentPagePath, "mobile")}</ul>
              </nav>
            </div>
          </div>
        </header>
        {backToPartnerBar}
      </div>
    )
  }
}

export default Header
